export default "__VITE_ASSET__ChfuoClQ__"